<template>
  <vs-row>
    <vs-col :vs-w="showFiltersTransition ? 9 : 12" class="p-2">
      <vx-card v-if="leaderboard">
        <div class="flex flex-end" v-if="filterValues">
          <feather-icon class="filter-hover-button" @click="onShowFilters()" icon="FilterIcon"
                        :svgClasses="'h-8 w-8 mb-1 mr-3 stroke-current text-primary'"/>
        </div>
        <sm-hateoas-table
          ref="leaderboardTable"
          :paged-resources="leaderboard"
          :relation="'leaderboard'"
          :pagination="true"
          :filters="filterValues">
          <template slot="thead">
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.first_name') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.last_name') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.total_referrals') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.accepted_referrals') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.acceptance_rate') }}
            </vs-th>
            <vs-th>
              {{ $t('dashboard.block.leaderboard.columns.expired_referrals') }}
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].firstName">
                {{ data[indextr].firstName}}
              </vs-td>
              <vs-td :data="data[indextr].lastName">
                {{ data[indextr].lastName}}
              </vs-td>
              <vs-td :data="data[indextr].totalReferrals">
                {{ data[indextr].totalReferrals}}
              </vs-td>
              <vs-td :data="data[indextr].acceptedReferrals">
                {{ data[indextr].acceptedReferrals}}
              </vs-td>
              <vs-td :data="data[indextr].acceptanceRate">
                {{ data[indextr].acceptanceRate}}%
              </vs-td>
              <vs-td :data="data[indextr].expiredReferrals">
                {{ data[indextr].expiredReferrals}}
              </vs-td>
            </vs-tr>
            </template>
        </sm-hateoas-table>
      </vx-card>
    </vs-col>
    <vs-col vs-w="3" class="p-2">
      <sm-hateoas-filters ref="onFilter" v-if="filters" :filter-resource="filterResource" v-show="showFiltersTransition" @update-transition="onUpdateFilterTransition"
                          :filters="filters" @filters-change="onFilterChange"></sm-hateoas-filters>
    </vs-col>
  </vs-row>
</template>

<script>
import SmHateoasFilters from '@/components/starling/sm-hateoas-filters/sm-hateoas-filters';
import SmHateoasTable from '@/components/starling/sm-hateoas-table/sm-hateoas-table';
import { ResourceImpl } from 'hal-client';

export default {
  name: 'view-leaderboard',
  components: {
    SmHateoasFilters,
    SmHateoasTable
  },
  props: {
    leaderboardResource: {
      type: ResourceImpl,
      required: true
    }
  },
  data () {
    return {
      leaderboard: this.leaderboardResource,
      filterResource: null,
      filters: null,
      filterValues: null,
      showFilters: false,
      showFiltersDelayed: false,
      showFiltersTransition: false
    };
  },
  mounted () {
    if (this.leaderboard.$hasLink('filters')) {
      this.leaderboard.$request().$get('filters').then(res => {
        this.filters = res.$getEmbedded('filters');
        this.filterResource = res;
      });
    }
  },
  methods: {
    onFilterChange (filters) {
      this.filterValues = filters;
    },
    onUpdateFilterTransition () {
      this.showFiltersTransition = !this.showFiltersTransition;
    },
    onShowFilters () {
      this.$refs.onFilter.onShowFilters();
    }
  }
};
</script>
